import { forwardRef, type InputHTMLAttributes } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, ...rest }, ref) => {
    const inputId = id ?? `cb-${rest.name ?? Math.random().toString(36).slice(2, 8)}`;
    return (
      <label
        htmlFor={inputId}
        className={cn('inline-flex items-center gap-2 cursor-pointer select-none', className)}
      >
        <span className="relative inline-flex h-4 w-4 shrink-0 items-center justify-center">
          <input
            ref={ref}
            id={inputId}
            type="checkbox"
            className="peer absolute inset-0 h-4 w-4 cursor-pointer opacity-0"
            {...rest}
          />
          <span
            className={cn(
              'absolute inset-0 rounded border border-line bg-white transition-colors',
              'peer-checked:bg-navy peer-checked:border-navy',
              'peer-focus-visible:shadow-focus',
            )}
          />
          <Check className="relative h-3 w-3 text-white opacity-0 peer-checked:opacity-100" />
        </span>
        {label && <span className="text-body text-ink">{label}</span>}
      </label>
    );
  },
);
Checkbox.displayName = 'Checkbox';
